/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const caseDetailsItemStyle = {
  label: (theme: Theme) => ({
    fontWeight: 400,
    paddingTop: "16px",
    [theme.breakpoints.up("md")]: {
      paddingRight: "8px",
    },
  }),
};

export default caseDetailsItemStyle;
